export default __webpack_public_path__ + "static/media/attendance-button-null.ad2521b1.png";